import { render, staticRenderFns } from "./CreateRequestPopup.vue?vue&type=template&id=2cb85cc6"
import script from "./CreateRequestPopup.vue?vue&type=script&lang=js"
export * from "./CreateRequestPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports